import { useState } from 'react';
import { PITCH_SCRIPTS, PITCH_CATEGORIES } from '../data/content';
import { Card, Badge, CopyButton, SectionLabel } from '../components/UI';

export default function ScriptsPage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeId, setActiveId] = useState(PITCH_SCRIPTS[0].id);

  const filtered = activeCategory === 'all' ? PITCH_SCRIPTS : PITCH_SCRIPTS.filter(s => s.category === activeCategory);
  const script = PITCH_SCRIPTS.find(s => s.id === activeId) || filtered[0];

  const handleCategory = (cat) => {
    setActiveCategory(cat);
    const first = cat === 'all' ? PITCH_SCRIPTS[0] : PITCH_SCRIPTS.find(s => s.category === cat);
    if (first) setActiveId(first.id);
  };

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 800, letterSpacing: '-0.03em', marginBottom: 6 }}>DM Scripts</h1>
        <p style={{ color: 'var(--text2)', fontSize: 14 }}>Battle-tested copy-paste pitches for every Web3 gig type. Pick one, fill in the blanks, send.</p>
      </div>

      {/* Category tabs */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {PITCH_CATEGORIES.map(cat => (
          <button key={cat.id} onClick={() => handleCategory(cat.id)} style={{
            padding: '6px 14px', borderRadius: 20, fontSize: 12, cursor: 'pointer',
            fontFamily: 'var(--font-mono)',
            background: activeCategory === cat.id ? 'var(--accent-dim)' : 'transparent',
            color: activeCategory === cat.id ? 'var(--accent)' : 'var(--text2)',
            border: activeCategory === cat.id ? '1px solid var(--accent)' : '1px solid var(--border)',
            transition: 'all 0.15s',
          }}>
            {cat.label} {activeCategory !== cat.id && <span style={{ color: 'var(--text3)' }}>({(cat.id === 'all' ? PITCH_SCRIPTS : PITCH_SCRIPTS.filter(s => s.category === cat.id)).length})</span>}
          </button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: 16, alignItems: 'start' }}>
        {/* Script list */}
        <div>
          <SectionLabel>Choose a script</SectionLabel>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: '70vh', overflowY: 'auto', paddingRight: 4 }}>
            {filtered.map(s => {
              const isActive = activeId === s.id;
              return (
                <button key={s.id} onClick={() => setActiveId(s.id)} style={{
                  textAlign: 'left', padding: '10px 14px',
                  background: isActive ? 'var(--accent-dim)' : 'var(--surface)',
                  border: `1px solid ${isActive ? 'var(--accent)' : 'var(--border)'}`,
                  borderRadius: 'var(--radius)', cursor: 'pointer', transition: 'all 0.15s',
                }}
                onMouseEnter={e => !isActive && (e.currentTarget.style.borderColor = 'var(--border2)')}
                onMouseLeave={e => !isActive && (e.currentTarget.style.borderColor = 'var(--border)')}
                >
                  <div style={{ fontSize: 13, fontWeight: 500, color: isActive ? 'var(--accent)' : 'var(--text)', marginBottom: 6, lineHeight: 1.3 }}>{s.label}</div>
                  <Badge color={s.badgeColor}>{s.badge}</Badge>
                </button>
              );
            })}
          </div>
        </div>

        {/* Active script */}
        {script && (
          <div>
            <SectionLabel>Script</SectionLabel>
            <Card>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, lineHeight: 1.3 }}>{script.label}</div>
                <CopyButton text={script.template} />
              </div>
              <div style={{
                background: 'var(--bg2)', borderRadius: 'var(--radius)',
                padding: '16px 18px', fontFamily: 'var(--font-mono)',
                fontSize: 13, lineHeight: 1.8, color: 'var(--text)',
                whiteSpace: 'pre-wrap', borderLeft: '2px solid var(--accent)',
              }}>
                {script.template.split(/(\[.*?\])/g).map((part, i) =>
                  part.startsWith('[') ? (
                    <span key={i} style={{
                      background: 'var(--amber-dim)', color: 'var(--amber)',
                      borderRadius: 4, padding: '1px 6px', fontWeight: 500,
                    }}>{part}</span>
                  ) : part
                )}
              </div>
              <div style={{ marginTop: 14, padding: '10px 14px', background: 'var(--accent-dim)', borderRadius: 'var(--radius)', fontSize: 13, color: 'var(--accent)' }}>
                <strong>Tip:</strong> Replace <span style={{ background: 'var(--amber-dim)', color: 'var(--amber)', borderRadius: 3, padding: '0 4px', fontFamily: 'var(--font-mono)', fontSize: 12 }}>[highlighted brackets]</span> with real project details before sending.
              </div>
            </Card>
          </div>
        )}
      </div>
    </div>
  );
}
